<template>
  <div class="contenedor-lista-actores" :class="{ 'lista-actores-oculta': !listaActoresVisible }">
    <div class="contenido-sticky">
      <div class="encabezado-lista">
        <span class="boton-esconder" @click="cambiarListaActoresVisible()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path
              d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
            />
          </svg>
        </span>

        <h3 class="titulo">
          <strong>Comunidad </strong>
          ({{ actoresPorBusquedaYControles.length }} persona{{
            actoresPorBusquedaYControles.length !== 1 ? "s" : ""
          }})
        </h3>
      </div>

      <div
        class="buscador-actores"
        :class="{ 'sin-resultaodos': actoresPorBusquedaYControles.length < 1 }"
      >
        <input type="text" placeholder="Buscar" v-model="textoBuscador" />
      </div>
    </div>

    <div class="lista-actores">
      <div class="item-actor" v-for="(actor, idx) in actoresPorBusquedaYControles" :key="idx">
        <span
          class="linea-color"
          :style="`background-color: ${
            require('@/components/mapas/utiles').coloresLineasEstrategicas[
              actor.id_linea_estrategica
            ]
          };`"
        />
        <div class="actor-detalle">
          <b>Nombre: </b>{{ actor.nombre_actor }}<br />
          <b>Cargo: </b>{{ actor.cargo_titulo }}<br />
          <b>Línea estratégica: </b>{{ actor.linea_estrategica_conacyt }}<br />
          <b>Sector: </b>{{ actor.sector }}<br />
          <b>Institución: </b>{{ actor.institucion }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import lista_actores from "@/assets/data/lista_actores.json";

export default {
  data: () => ({
    /**
     * Variable reactiva al contenido del ingresado en la caja (input) de búsqueda
     * @type String
     */
    textoBuscador: "",
  }),
  computed: {
    ...mapState("mapaActores", ["listaActoresVisible"]),
    ...mapGetters("mapaActores", [
      "actualCvePais",
      "actualCveEdo",
      "actualCveLineaEstrategica",
      "actualRelacionActoresFiltrados",
    ]),

    /**
     * Devuelve los ids de los actores filtradosm por la caja de búsqueda cuando esta tenga más
     * de dos caracteres escritos
     * > La lista se maneja cómo string por que es más facil de observar por el watcher de vue,
     * evitando actualizar el store cuando no sea completamente necesario.
     * @returns {String} ids de los actores filtrdos en formato array json
     */
    idsActoresPorBusqueda() {
      const textoBuscar = textoSimple(this.textoBuscador);
      if (textoBuscar && textoBuscar.length > 2) {
        return idsArrayString(filtroBuscador(textoBuscar));
      }
      return idsArrayString(lista_actores);
    },

    /**
     * Filtra, de la lista de actores original, aquellos que coincidan primero con los creiterios
     * de la caja de búsqueda y posterirormente con el filtro de los controles externos a la lista
     * @returns {Array<Object>} Lista de actores filtrada con todos los atributos de cada actor
     */
    actoresPorBusquedaYControles() {
      return lista_actores
        .filter((actor) => JSON.parse(this.idsActoresPorBusqueda).includes(actor.g_id))
        .filter((actor) => this.actualRelacionActoresFiltrados("g_id").includes(actor.g_id))
        .sort((a, b) => textoSimple(a.nombre_actor) > textoSimple(b.nombre_actor));
    },
  },
  watch: {
    /**
     * Caundo los ids de los actores filtrados por la caja de búsqueda cambien, notificar al store
     * para que se pueda reflejar el filtro en el mapa.
     *
     * > La lista se maneja cómo string por que es más facil de observar por el watcher de vue,
     * evitando actualizar el store cuando no sea completamente necesario.
     */
    idsActoresPorBusqueda(nuevoValor) {
      this.cambiarIdsUbicacionesPuntos(JSON.parse(nuevoValor));
    },

    /**
     * Caundo cambie el país seleccionado, resetear buscador
     */
    actualCvePais() {
      this.textoBuscador = "";
    },

    /**
     * Caundo cambie el estado seleccionado, resetear buscador
     */
    actualCveEdo() {
      this.textoBuscador = "";
    },

    /**
     * Caundo cambie la línea estratégica seleccionada, resetear buscador
     */
    actualCveLineaEstrategica() {
      this.textoBuscador = "";
    },
  },
  methods: {
    ...mapMutations("mapaActores", ["cambiarListaActoresVisible"]),
    ...mapActions("mapaActores", ["cambiarIdsUbicacionesPuntos"]),
  },
};

/**
 * Devuelve un string con la lista de los g_id, en estructura array json, de la lista de objetos
 * de actores que llegue como parámetro.
 * @param {Array<Object>} [actores]
 * @returns {String}
 */
function idsArrayString(actores) {
  return JSON.stringify(actores.map((i) => i.g_id));
}

/**
 * Contiene la lógica para filtrar los actores que coincidan, en texto simplificado, con nombre,
 * cargo e institución.
 * @param {String} [textoBuscar]
 * @returns {Array<Object>}
 */
function filtroBuscador(textoBuscar) {
  return lista_actores.filter(
    (actor) =>
      textoSimple(actor.nombre_actor).includes(textoBuscar) ||
      textoSimple(actor.cargo_titulo).includes(textoBuscar) ||
      textoSimple(actor.institucion).includes(textoBuscar)
  );
}

/**
 * Simplifica texto eliminando espacios al inicio o al final y quita caracteres especiales.
 * @param {String} [texto]
 * @returns {String}
 */
function textoSimple(texto) {
  return texto
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}
</script>

<style lang="scss">
.contenedor-lista-actores {
  $border: 1px solid #000;
  $web: map-get($media-queries-limit, "mobile") + 1;
  $movil: map-get($media-queries-limit, "mobile");
  $espacio-colores: 24px;

  height: 100%;

  @media (min-width: $web) {
    &.lista-actores-oculta {
      .contenido-sticky > .encabezado-lista,
      .lista-actores > .item-actor {
        flex-direction: row-reverse;
      }

      .contenido-sticky {
        .encabezado-lista > span.boton-esconder > svg {
          margin-right: -4px;
          transform: rotate(90deg);
        }

        .buscador-actores {
          margin-left: 0;
        }
      }
    }
  }

  .contenido-sticky {
    position: sticky;
    top: 0;

    .encabezado-lista {
      display: flex;
      flex-direction: row;
      background-color: #fff;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);

      span.boton-esconder {
        min-width: $espacio-colores;
        display: flex;
        align-items: center;
        justify-content: center;

        @media (max-width: $movil) {
          display: none;
        }

        svg {
          height: 26px;
          transform: rotate(-90deg);
        }
      }

      > h3.titulo {
        margin: 10px;
        font-size: 16px;
        font-weight: normal;
        line-height: inherit;
      }
    }

    .buscador-actores {
      margin-left: $espacio-colores;
      width: calc(100% - $espacio-colores);
      position: absolute;
      padding: 8px;

      input[type="text"] {
        height: 40px;
        width: 100%;
        padding: 0;
        margin: 0;
        background-color: #fff;
        font-weight: normal;
        padding: 4.5px 9px;
      }

      &.sin-resultaodos {
        position: static;
        margin-left: 0;
        width: 100%;
      }
    }
  }

  .lista-actores {
    .item-actor {
      display: flex;
      flex-direction: row;
      border-top: 1px solid rgba(0, 0, 0, 0.2);

      > span.linea-color {
        min-width: $espacio-colores;
      }

      > div.actor-detalle {
        padding: 8px;
      }

      &:first-child {
        border-top: none;
        > div.actor-detalle {
          margin-top: 48px;
        }
      }
    }
  }
}
</style>
